import api from 'services/api'
import {
  GET_SOCIETIES_LIST,
  DELETE_SOCIETY,
  CREATE_SOCIETY,
  UPDATE_SOCIETY,
  GET_SOCIETY_DETAIL,
  GET_CITIES,
  GET_STATES
} from '../endpoints'

export const getSocietiesList = async (body) => await api.post(GET_SOCIETIES_LIST, body)

export const deleteSociety = async (society_id) =>
  await api.delete(DELETE_SOCIETY, {data: {society_id}})

export const submitSociety = async (values, id) =>
  await api.post(id ? UPDATE_SOCIETY : CREATE_SOCIETY, values)

export const getSocietyDetail = async (society_id) =>
  await api.get(`${GET_SOCIETY_DETAIL}?society_id=${society_id}`)

export const getStateDetail = async () =>
  await api.get(`${GET_STATES}`)

export const getCitiesDetail = async (state_id) =>
  await api.get(`${GET_CITIES}?state_id=${state_id}`)
